import React from 'react';
import { Stack } from '@chakra-ui/react';

export default function ICol({ children }) {
  return <Stack w="100%">{children}</Stack>;
}
